// Global logger utility that only logs in development mode
const isDev = import.meta.env.DEV;

// Create a logger object with methods that only log in development mode
export const logger = {
  log: (...args: any[]) => {
    if (isDev) {
      console.log(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (isDev) {
      console.error(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isDev) {
      console.warn(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDev) {
      console.info(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (isDev) {
      console.debug(...args);
    }
  },
  
  // Special method that always logs, even in production (for critical errors)
  critical: (...args: any[]) => {
    console.error('[CRITICAL]', ...args);
  }
};

// Create a function to get a namespaced logger
export const getLogger = (namespace: string) => {
  return {
    log: (...args: any[]) => logger.log(`[${namespace}]`, ...args),
    error: (...args: any[]) => logger.error(`[${namespace}]`, ...args),
    warn: (...args: any[]) => logger.warn(`[${namespace}]`, ...args),
    info: (...args: any[]) => logger.info(`[${namespace}]`, ...args),
    debug: (...args: any[]) => logger.debug(`[${namespace}]`, ...args),
    critical: (...args: any[]) => logger.critical(`[${namespace}]`, ...args)
  };
};